export var DiscourseType;
(function (DiscourseType) {
    DiscourseType["Statement"] = "statement";
    DiscourseType["Expected"] = "expected";
})(DiscourseType || (DiscourseType = {}));
export { DiscourseType as Type };
export default DiscourseType;
//# sourceMappingURL=Type.js.map